function pushHistory(indexes) {
  let current = parseHistory()
  if (current.bible === indexes.bible
    && current.book === indexes.book
    && current.chapter === indexes.chapter
    && current.verse === indexes.verse
    ) {
    return
  }

  let params = new URLSearchParams()
  params.set('bible', indexes.bible)
  params.set('book', indexes.book)
  params.set('chapter', indexes.chapter)
  params.set('verse', indexes.verse)
  history.pushState(null, null, '?' + params.toString());
}

function parseHistory() {
  let params = new URLSearchParams(location.search)
  let indexes = {
    bible: params.get('bible') || 'SI',
    book: params.get('book') || 'GEN',
    chapter: parseInt(params.get('chapter')) || 0,
    verse: parseInt(params.get('verse')) || 0,
  }
  return indexes
}

export {
  pushHistory,
  parseHistory,
}
